import AddInstaller from "./AddAccessory";

export default AddInstaller;
